import Repository from './Repository';

const resource = '/v1';
const adminResource = '/v2/admin';

export default {
    getUserInfo() {
        return Repository.get(`${resource}/auth/me`);
    },
    uploadImage(base64) {
        return Repository.post(`${resource}/upload/image`, {base64});
    },
    getUsers(query) {
        return Repository.get(`${adminResource}/users`, {params: query});
    },
    postCreateOrUpdateUser(user) {
        return Repository.post(`${adminResource}/users`, user);
    },
    getArts(query) {
        return Repository.get(`${adminResource}/arts`, {params: query});
    },
    postCreateArt(art) {
        return Repository.post(`${adminResource}/arts`, art);
    },
    getProducts() {
        return Repository.get(`${resource}/products`);
    },

    getPartnerProductList(partnerKey, authToken) {
        return Repository.get(`${resource}/partners/${partnerKey}/products`, {
            headers: {
                Authorization: authToken,
            },
        });
    },
    getPartnerOrderList(partnerKey, orderStateList, startDate, endDate, authToken) {
        return Repository.get(`${resource}/partners/${partnerKey}/orders`, {
            params: {orderStateList: orderStateList.join(','), startDate, endDate},
            headers: {
                Authorization: authToken,
            },
        });
    },
    getPartnerArt(partnerKey, artId, authToken) {
        return Repository.get(`${resource}/partners/${partnerKey}/arts/${artId}`, {
            headers: {
                Authorization: authToken,
            },
        });
    },
    postPartnerOrder(partnerKey, order, authToken) {
        return Repository.post(`${resource}/partners/${partnerKey}/orders`, order, {
            headers: {
                Authorization: authToken,
            },
        });
    },
    postCafe24Init(mallId, code, redirectUrl, shopNo) {
        return Repository.post(`${resource}/cafe24/init`, {mallId, code, redirectUrl, shopNo});
    },
    putCafe24UpdateScript(mallId, shopNo, authToken) {
        return Repository.put(`${resource}/cafe24/script`, {mallId, shopNo}, {
            headers: {
                Authorization: authToken,
            },
        });
    },
    postCafe24CreateCategory(mallId, shopNo, authToken) {
        return Repository.post(`${resource}/cafe24/categories`, {mallId, shopNo}, {
            headers: {
                Authorization: authToken,
            },
        });
    },
};
